// eslint-disable-next-line import/no-extraneous-dependencies
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import PostCard from '@/components/Post/PostCard';
import { useGetPostsQuery } from './post.api.slice';
import useSearchParamActions from '@/customHooks/useSearchParamActions';
import { IPostWithUserAndAttachments } from './post.d';
import { selectCurrentUser } from '../auth/auth.slice';

function FeaturedPostsList() {
  const [postsData, setPostsData] = useState<IPostWithUserAndAttachments[]>([]);
  const [page, setPage] = useState(1);
  const { getSearchParam } = useSearchParamActions();
  const { user } = useSelector(selectCurrentUser);

  const category = getSearchParam('category');
  const subCategory = getSearchParam('subCategory');
  const postedAt = getSearchParam('postedAt');
  const author = getSearchParam('author');
  const toolType = getSearchParam('toolType');
  const partner = getSearchParam('partner');

  const { data: posts, isLoading } = useGetPostsQuery({
    category,
    subCategory,
    postedAt,
    author,
    page,
    toolType,
    partner,
  });

  useEffect(() => {
    setPostsData([]);
    setPage(1);
  }, [category, subCategory, postedAt, author]);

  useEffect(() => {
    if (!isLoading && posts?.length) {
      if (page === 1) {
        setPostsData(posts);
      } else {
        setPostsData((prev) => {
          const newPosts = posts.filter(
            (post) => !prev.some((p) => p._id === post._id)
          );
          return [...prev, ...newPosts];
        });
      }
    }
  }, [posts, page, isLoading]);

  const fetchMoreData = () => {
    setPage((prev) => prev + 1);
  };

  return (
    <InfiniteScroll
      dataLength={postsData.length}
      next={fetchMoreData}
      hasMore={(posts?.length ?? 0) === 20}
      loader={
        <>
          {Array.from({ length: 20 }).map((_, index) => (
            <Skeleton key={index} className="w-[342px] h-[478px]" />
          ))}
        </>
      }
      className="flex flex-wrap sm:justify-start justify-center py-2 w-full gap-10 items-center"
    >
      {postsData?.map((post) => (
        <PostCard
          key={post._id}
          id={post._id}
          authorName={`${post?.user?.firstname} ${post?.user?.lastname}`}
          authorAvatar={post?.user?.profilePicture}
          authorUsername={post?.user?.username}
          title={post.title}
          description={post.description}
          likesCount={post.likes}
          commentsCount={post.comments}
          attachments={post.attachments}
          createdAt={post.createdAt}
          category={post.category}
          hasLikedByUser={post?.hasLikedByUser}
          isOnefinityOfficial={post?.user?.isOnefinityOfficial}
          isOwner={post?.user?._id === user?._id}
          partnerData={post?.partner}
        />
      ))}
    </InfiniteScroll>
  );
}

export default FeaturedPostsList;
